import { ErrorResponse, LocalDate, NumberDate } from '@lemon/core/model/common'

export interface SelvitettavienTilanneraporttiPyynto {}

export interface SelvitettavienTilanneraporttiVastaus {
  tiedostot: { [tiedostonimi: string]: string }
}

export enum YllapitoTilastonTyyppi {
  LOPETTAVAT = 'lopettavat',
  ALOITTAVAT = 'aloittavat',
  HINNANMUUTOKSET = 'hinnanmuutokset',
  SOPIMUSTYYPPIEN_MUUTOKSET = 'sopimustyyppien-muutokset',
  POYTALAATIKKO_JA_TAUKOSOPIMUSTEN_KESTOT = 'poytalaatikko-ja-taukosopimusten-kestot',
  SAAMISET_OSAKKAILTA_JA_OMAISILTA = 'saamiset-osakkailta-ja-omaisilta',
  ASIAKKAAT_JA_HINNAT = 'asiakkaat-ja-hinnat',
  ASIAKKAAT_JA_HINNAT_JA_LIIKEVAIHTO = 'asiakkaat-ja-hinnat-ja-liikevaihto',
  LASKUJEN_TUOTTEET = 'laskujen-tuotteet',
}

export interface YllapitoTilastotPyynto {
  tyyppi: YllapitoTilastonTyyppi
  alku: NumberDate
  loppu: NumberDate
}

export interface YllapitoTilastotVastaus extends ErrorResponse {
  csv: string
  filename: string
}

export interface YlisuorituksetJaEraantyneetPyynto {
  paiva: LocalDate
}

export interface YlisuorituksetJaEraantyneetVastaus extends ErrorResponse<'missing-data' | 'unauthorized' | 'unknown-error'> {
  csv?: string
  filename?: string
}
